<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Deduct Balance",
      items: [
        {
          text: "Deduct",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
        users:[],
        allusers:[],
      errors: null,
        lineError:true,
        visible:false,
        message:"",
        user_type:"",
      form: {
        user_id: undefined,
        pin: "",
          amount:"",
          remarks:""
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      user_id: {
        required,
      },
      pin: {
        required,
      },
        amount: {
            required,
        },
        remarks: {
            required,
        },
    },
  },
    mounted() {
        this.getAdminList();
    },
  methods: {
      onClose(){
          this.visible=false;
          this.lineError=false;
      },
      async getAdminList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c'){
                                  if(temp[i].first_name==null){
                                      temp[i].text=temp[i].email + '(unregistered)';
                                  }else{
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  }
                                  temp[i].value = temp[i].id;
                                  arr.push(temp[i]);
                              }

                          }
                          this.allusers=arr;
                          this.users = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/deduct-balance", {
            user_id: this.form.user_id,
            pin: this.form.pin,
            amount:this.form.amount,
            remarks:this.form.remarks,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
              this.errors=null;
              this.form.user_id=undefined;
              this.form.pin=undefined;
              this.form.amount=undefined;
              this.form.remarks=undefined;
              this.$refs.depositEntryForm.reset();
              if(this.visible){
                  this.visible=false;
              }
             this.$swal("Good job!", "Deduction Successful", "success");
              this.$router.push({ name: "deposit_deduct_balance" });
              this.submitted=false;
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
      onChange(event) {
          this.user_type=event.target.value;
          var temp=this.allusers;
          var arr=[];
          var i;
          for (i=0;i<temp.length;i++){
              if (temp[i].account_type==event.target.value){
                  arr.push(temp[i]);
              }
          }
          this.users = arr;
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if(obj.error){
            if (obj.message==="Amount is not available") {
                this.visible=true;
                this.message="Amount is not available";
            } else if(obj.message==="need to create PIN first"){
                this.visible=true;
                this.errors="need to create PIN first"
            }else if (obj.message==="PIN doesn't match") {
                this.visible=true;
                this.message="PIN doesn't match";
            }
            this.errors = obj.message;
        }
        else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      // console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors && !visible && lineError" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="depositEntryForm" @submit.prevent="formSubmit">
              <div class="row">
                  <div class="col-md-6">
                      <div class="form-group">
                          <label for="user_type">Select User Type</label>
                          <select
                              id="user_type"
                              name="user_type"
                              v-model="user_type"
                              @change="onChange($event)"
                              class="form-control"
                              placeholder="Select User Type">
                              <option value="b2b">B2B
                              </option>
                              <option value="b2c">B2C
                              </option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Select User</label>
                          <model-select :options="users"
                                        v-model="form.user_id"
                                        :class="{ 'is-invalid': submitted && $v.form.user_id.$error }"
                                        placeholder="Select User">
                          </model-select>
                           <div
                             v-if="submitted && $v.form.user_id.$error"
                             class="invalid-feedback"
                           >
                             <span v-if="!$v.form.user_id.required">This value is required.</span>
                           </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label for="admin_pin">Admin pin</label>
                          <input
                              id="admin_pin"
                              v-model="form.pin"
                              name="admin_pin"
                              type="password"
                              class="form-control"
                              placeholder="Type Admin Pin"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.pin.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.pin.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.pin.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="amount">Deduct Amount</label>
                    <input
                      id="amount"
                      v-model="form.amount"
                      name="amount"
                      type="text"
                      class="form-control"
                      placeholder="Type amount"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.amount.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.amount.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.amount.required">This value is required.</span>
                    </div>
                  </div>
                </div>

                  <div class="col-md-6">
                      <div class="form-group">
                          <label for="admin_remarks">Remarks</label>
                          <input
                              id="admin_remarks"
                              v-model="form.remarks"
                              name="admin_remarks"
                              type="text"
                              class="form-control"
                              placeholder="Type Remarks"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.pin.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.pin.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.pin.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
